import { z } from "zod";

// Self-registration email verification (passport-web /verify-email → POST /auth/verify-email).
// token = 32-byte base64url (43 chars), same shape as the reset/invite tokens.
export const verifyEmailRequestSchema = z.object({
  token: z.string().regex(/^[A-Za-z0-9_-]{43}$/, "Invalid verification token"),
});
